<template>
    <div>
        <div class="sys-device-option">
            <span>Device {{ index + 1 }}</span>
            <img src="../../../../assets/icon/delete.png" style="width: 17px;height: 17px;cursor: pointer;"
                @click="deleteData" v-if="index !== 0" />
        </div>

        <el-form :model="ruleForm" :rules="rules" ref="modalForm" label-width="170px"
            :label-position="isMobile() ? 'top' : 'right'">

            <el-form-item :label="$t('client.device.manufacturer') + '：'" prop="deviceType">
                <el-select v-model="ruleForm.deviceType" size="medium" @change="changeDeviceType">
                    <el-option v-for="item in deviceTypeList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('client.device.site') + '：'" key="outletId" prop="outletId">
                <el-select v-model="ruleForm.outletId" size="medium">
                    <el-option v-for="item in outletList" :label="item.outletName" :value="item.outletId"
                        :key="item.outletId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('client.device.deviceName') + '：'" prop="deviceName">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.deviceName" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="$t('client.device.domain') + '：'" prop="address">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.address" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="$t('client.device.port') + '：'" prop="tcpPort">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.tcpPort" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="$t('client.device.streamPort') + '：'" prop="streamPort">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.streamPort" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="$t('client.device.username') + '：'" prop="userName">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.userName" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="$t('client.device.password') + '：'" prop="passwd">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.passwd" size="medium"
                    show-password maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="$t('client.device.realTimeStream') + '：'" prop="defaultLiveVideo">
                <el-select v-model="ruleForm.defaultLiveVideo" size="medium">
                    <el-option v-for="item in streamList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('client.device.playbackStream') + '：'" prop="defaultPlayBackStream">
                <el-select v-model="ruleForm.defaultPlayBackStream" size="medium">
                    <el-option v-for="item in streamList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('client.device.channelNum') + '：'" prop="chanNum">
                <el-input-number :min="1" :max="999999999" :precision="0" style="width:232px;" @change="handleChange"
                    v-model="ruleForm.chanNum"></el-input-number>
            </el-form-item>

            <div v-if="calcLength" class="sys-channel-div">
                <el-form-item v-for="(channel, index) in ruleForm.channelList"
                    :label="$t('client.device.channel') + (index + 1) + '：'"
                    :prop="'channelList[' + index + '].cameraName'"
                    :rules="{ required: true, message: $t('common.commontip'), trigger: 'blur' }"
                    :key="'channel_' + index">
                    <el-input v-model="channel.cameraName" :placeholder="$t('common.inputplaceholder')" size="medium"
                        maxlength="32"></el-input>
                </el-form-item>
            </div>
        </el-form>


    </div>
</template>

<script>
export default {
    props: {
        outletList: {
            type: Array,
            default() {
                return []
            }
        },
        index: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    data() {
        return {
            deviceTypeList: [{ label: 'HIKVISION', value: 4 }, { label: 'DAHUA', value: 5 }, { label: 'Uniview', value: 15 }, { label: 'Onvif', value: 10 }],
            calcLength: 0,
            ruleForm: {
                deviceType: null,
                outletId: null,
                deviceName: null,
                address: null,
                tcpPort: null,
                streamPort: 554,
                userName: null,
                passwd: null,
                defaultLiveVideo: 1,
                defaultPlayBackStream: 0,
                channelList: [],
            },
            streamList: [
                { label: vm.$t('client.device.mainStream'), value: 0 },
                { label: vm.$t('client.device.subStream'), value: 1 },
            ],
            rules: {
                deviceType: [{ required: true, message: vm.$t('common.commontip') }],
                outletId: [{ required: true, message: vm.$t('common.commontip') }],
                deviceName: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                address: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                userName: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                passwd: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                chanNum: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur'}],
            }
        }
    },
    mounted() {

    },
    methods: {
        isMobile() {
            var userAgentInfo = navigator.userAgent;
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(userAgentInfo)) {
                return true;
            } else {
                return false;
            }
        },
        changeDeviceType(val) {
            if (val === 4) {
                this.ruleForm.tcpPort = 8000;
            } else if (val === 5) {
                this.ruleForm.tcpPort = 30000;
            } else if ([15, 10].includes(val)) {
                this.ruleForm.tcpPort = 80;
            }
        },
        handleChange(val) {
            if (val) {
                let list = [];
                for (let i = 0; i < val; i++) {
                    let initVal = this.ruleForm.channelList.length > i ? this.ruleForm.channelList[i].cameraName : null;
                    let devVal = this.ruleForm.deviceName ? this.ruleForm.deviceName + 'CH' + (i + 1) : '';
                    list.push({ chanIndex: i + 1, cameraName: initVal || devVal });
                }
                this.ruleForm.channelList = list;
            }
            this.$refs.modalForm.validateField('chanNum');
            this.calcLength = val;
        },
        deleteData() {
            this.$emit('deleteData', this.index);
        },
        validFormData() {
            let flag = false;
            this.$refs.modalForm.validate((valid) => {
                flag = valid;
            });
            return { flag, data: this.ruleForm };
        }
    }
}
</script>

<style scoped>
.sys-device-option {
    font-weight: bold;
    color: #5B647D;
    margin: 20px 0 10px 0;
    display: flex;
    justify-content: space-between;
}

.sys-channel-div {
    background-color: #F8F8F8;
    border-radius: 2px;
    padding: 15px 15px 15px 0;
}
</style>